import { useState } from 'react'

import { Popconfirm as AntPopconfirm, PopconfirmProps } from 'antd'

const Popconfirm = (props: PopconfirmProps) => {
    const { children, ...rest } = props

    // Prevent the popconfirm from closing while interacting with possible inputs in
    // the children component.
    const [open, setOpen] = useState(false)

    return (
        <AntPopconfirm
            {...rest}
            open={open}
            destroyTooltipOnHide
            onOpenChange={(params) => {
                if (!open) {
                    setOpen(true)
                }

                rest.onOpenChange?.(params)
            }}
            onCancel={(e) => {
                setOpen(false)
                rest.onCancel?.(e)
            }}
            onConfirm={(e) => {
                setOpen(false)
                rest.onConfirm?.(e)
            }}
        >
            {/** Native HTML element needed for children: https://ant.design/components/tooltip#why-does-the-warning-finddomnode-is-deprecated-some-times-appear-in-strict-mode */}
            <div>{children}</div>
        </AntPopconfirm>
    )
}

export default Popconfirm
